<template>
  <common-modal
    :name="name"
    :title="title"
    :hideFooter="true"
    height="320px"
    width="800px"
  >
    <template #modal-body>
      <validation-form @on-submit="updateActivity">
        <md-card class="my-0">
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-50">
                <validation-field
                  :validations="classValidation.name"
                  name="name"
                >
                  <label>{{ $t("class.activity_name") }}</label>
                  <md-input v-model.trim="form.name" required></md-input>
                  <span
                    style="top:30px"
                    class="md-error"
                    v-if="serverValidations.name"
                    >{{ serverValidations.name }}</span
                  >
                </validation-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <label :for="select.name">{{ $t(select.label) }} </label>
                  <md-select
                    required
                    v-model="form.class_activity_category_id"
                    :name="select.name"
                    :id="select.name"
                    :multiple="select.multiple"
                  >
                    <md-option
                      v-for="option in select.options"
                      :value="option.id"
                      :key="option.id + option.name"
                      >{{ option.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <validation-field
                  :validations="classValidation.maxPoint"
                  name="max point"
                >
                  <label> {{ $t("class.max_point") }} </label>
                  <md-input v-model="form.max_point" required></md-input>
                  <span
                    style="top:30px"
                    class="md-error"
                    v-if="serverValidations.name"
                    >{{ serverValidations.max_point }}</span
                  >
                </validation-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <div class=" form-actions text-right pt-3 pb-3">
          <div class="md-layout">
            <div class="md-layout-item md-size-50"></div>
            <div class="md-layout-item md-size-50">
              <md-card
                class="tooltip"
                :class="{ hidden: !tooltipActive }"
                v-click-outside="closeCardConfirmDelete"
              >
                <div class="md-layout">
                  <div class="md-layout-item md-side-100 pt-4">
                    {{
                      $t("class.are_you_sure_you_want_to_delete_this_activity")
                    }}
                  </div>
                  <div class="md-layout-item md-size-100">
                    <a
                      class="pr-5 text-red-500 cursor-pointer"
                      @click="deleteActivity"
                      >{{ $t("common.yes") }}</a
                    >
                    <a
                      class="pl-5 text-green-500 cursor-pointer"
                      @click="closeCardConfirmDelete"
                      >{{ $t("common.no") }}</a
                    >
                  </div>
                </div>
              </md-card>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-button class="md-raised mr-3">{{
                $t("common.cancel")
              }}</md-button>
              <md-button
                class="md-raised md-danger mr-3"
                @click="confirmDeleteActivity"
                >{{ $t("common.delete") }}</md-button
              >
              <md-button type="submit" class="md-success mr-3">{{
                $t("common.update")
              }}</md-button>
            </div>
          </div>
        </div>
      </validation-form>
    </template>
  </common-modal>
</template>

<script>
import CommonModal from "@/components/Base/CommonModal";
import { parameterValidations } from "@/validations/classes";
import { service_names, service_paths } from "@/constants/Services";
import { genErrMsgOj, Message } from "@/helpers/utils";
import { Class } from "@/constants/Permissions";
import cloneDeep from "lodash/cloneDeep";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters } from "vuex";
import Role from "@/constants/Role";

export default {
  components: { CommonModal },
  props: [
    "name",
    "title",
    "isDisableAction",
    "dataDetail",
    "defaultData",
    "scoreList"
  ],
  inject: ["getScores"],
  data() {
    const classId = this.$route.params.id;
    return {
      pathGetCategories: `${service_paths.class_activity_categories}/class/${classId}`,
      path: `${service_names.school}/class-activities/activities/class/${classId}`,
      classId: classId,
      form: cloneDeep(this.dataDetail),
      serverValidations: {},
      classValidation: parameterValidations,
      select: {
        label: "class.category",
        name: "status__",
        value: "",
        type: "select",
        options: []
      },
      tooltipActive: false,
      isConfirmClick: false,
      Class
    };
  },
  watch: {
    dataDetail: function(newVal) {
      this.form = cloneDeep(newVal);
    }
  },
  created() {
    this.getParameters();
  },
  methods: {
    closeCardConfirmDelete() {
      if (this.isConfirmClick) {
        this.isConfirmClick = false;
        return;
      }
      this.tooltipActive = false;
    },
    confirmDeleteActivity() {
      this.isConfirmClick = true;
      this.tooltipActive = !this.tooltipActive;
    },
    deleteActivity() {
      const activityId = this.defaultData.id;
      const path = `${service_names.school}/activity-class-lms/${activityId}`;
      this.$axios.delete(path).then(() => {
        this.getScores();
        this.closeModal();
      });
    },
    getMaxScoreActivity(scoreList) {
      let listScore = [];
      const checkActivityValid = (value1, value2) => {
        return (
          value1.name === value2.name &&
          value1.class_activity_category_id ===
            value2.class_activity_category_id
        );
      };
      scoreList.map(score => {
        score.class_activity_categories.map(category => {
          category.activity_class_lms.map(activty => {
            if (checkActivityValid(activty, this.defaultData)) {
              listScore.push(activty.score.score);
            }
          });
        });
      });
      return Math.max(...listScore);
    },
    updateActivity() {
      const currentMaxScore = this.getMaxScoreActivity(this.scoreList);
      const isBigger = (firstVal, secVal) => {
        return parseFloat(firstVal) > parseFloat(secVal);
      };
      if (isBigger(currentMaxScore, this.form.max_point)) {
        Message.error(this.$t("class.the_max_point_must_be_greater"));
        return;
      }
      const form = Object.assign(
        {},
        {
          name: this.form.name,
          max_point: this.form.max_point,
          class_activity_category_id: this.form.class_activity_category_id,
          class_id: this.classId
        }
      );
      const activityId = this.form.id;
      this.$axios
        .put(`${service_names.school}/activity-class-lms/${activityId}`, form)
        .then(() => {
          Message.success(this.$t("common.edit_success"));
          this.getScores();
          this.closeModal();
        });
    },
    closeModal() {
      this.$modal.hide(this.name);
    },
    getParameters() {
      return this.$axios
        .get(
          this.pathGetCategories,
          { undefined },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          if (response.data) {
            this.select.options = response.data
              .filter(item => !item.is_default)
              .map(item => {
                return { name: item.name, id: item.id };
              });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.tooltip {
  position: absolute;
  top: 90px;
  z-index: 4;
  width: 215px;
  height: 125px;
  left: 480px;
  text-align: center;
  background: #f1e8dc;
  box-shadow: gray;
  border-radius: 20px;
}
</style>
